// Popup.jsx (최종 통합본 - Arrow SVG 적용)
import React, { useEffect, useState, useRef } from 'react';
import './Popup.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';

const ArrowIcon = ({ direction = 'left' }) => {
  const isLeft = direction === 'left';
  return (
    <svg className="popup-arrow-ic" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
      {isLeft ? (
        <path
          d="M14.5 5.5L8 12l6.5 6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M9.5 5.5L16 12l-6.5 6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

const Popup = () => {
  const [popups, setPopups] = useState([]);
  const [showPopup, setShowPopup] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const roots = 'https://ciuc.or.kr:8443';

  const sliderRef = useRef(null);

  useEffect(() => {
    fetchPopups();
  }, []);

  useEffect(() => {
    const hiddenUntil = localStorage.getItem('popupHiddenUntil');
    if (hiddenUntil) {
      const today = new Date().toISOString().slice(0, 10);
      if (hiddenUntil === today) setShowPopup(false);
    }
  }, []);

  const fetchPopups = async () => {
    try {
      const response = await axios.get('https://ciuc.or.kr:8443/api/get/popup_print');
      setPopups(response.data.data || []);
    } catch (error) {
      console.error('Error fetching popups:', error);
    }
  };

  const handleClosePopup = () => setShowPopup(false);

  const handleHideForToday = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem('popupHiddenUntil', today);
    setShowPopup(false);
  };

  const handleTogglePlay = () => {
    if (!sliderRef.current) return;
    if (isPlaying) sliderRef.current.slickPause();
    else sliderRef.current.slickPlay();
    setIsPlaying((prev) => !prev);
  };

  const handlePrev = () => sliderRef.current?.slickPrev();
  const handleNext = () => sliderRef.current?.slickNext();

  const numPopups = popups.length;

  const settings = {
    dots: true,
    arrows: false,
    infinite: numPopups > 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: numPopups > 3,
    speed: 600,
    autoplaySpeed: 3000,
    cssEase: 'ease-in-out',
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  if (!showPopup || popups.length === 0) return null;

  return (
    <div className="popup-container">
      <div className="popup-content">
        {/* ✅ 버튼태그로 변경(접근성/포커스/키보드) */}
        <button type="button" className="popup-arrow popup-arrow-prev" onClick={handlePrev} aria-label="이전">
          <ArrowIcon direction="left" />
        </button>

        <button type="button" className="popup-arrow popup-arrow-next" onClick={handleNext} aria-label="다음">
          <ArrowIcon direction="right" />
        </button>

        <div className="popup-slider-wrap">
          <Slider ref={sliderRef} {...settings}>
            {popups.map((popup, index) => {
              const img = (
                <div className="popup-frame" style={{ '--bg': `url(${roots}${popup.file_url})` }}>
                  <img src={`${roots}${popup.file_url}`} alt={popup.title || 'popup'} loading="lazy" />
                </div>
              );

              return (
                <div key={index} className="popup">
                  {popup.url ? (
                    <a href={popup.url} target="_blank" rel="noopener noreferrer">
                      {img}
                    </a>
                  ) : (
                    img
                  )}
                </div>
              );
            })}
          </Slider>
        </div>

        <div className="popup-buttons">
          {numPopups > 3 && (
            <button className="btn-outline" onClick={handleTogglePlay}>
              {isPlaying ? '일시정지' : '자동재생'}
            </button>
          )}
          <button className="btn-soft" onClick={handleHideForToday}>
            오늘 하루 보지 않기
          </button>
          <button className="btn-primary" onClick={handleClosePopup}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
